import { WindowTitle } from "@saleor/components/WindowTitle";
import { sectionNames } from "@saleor/intl";
import { parse as parseQs } from "qs";
import * as React from "react";
import { useIntl } from "react-intl";
import { Route, Routes } from "react-router-dom";

import { ExpressFleetListUrlQueryParams, expressFleetOpsUrl } from "./urls";
import ExpressFleetListView from "./views/ExpressFleetList";
import ExpressFleetOpsPage from "./views/ExpressFleetOpsPage";

const ExpressFleetListComponent: React.FC = () => {
  const qs = parseQs(location.search.substring(1));
  const params: ExpressFleetListUrlQueryParams = qs;

  return <ExpressFleetListView params={params} />;
};

const Component = () => {
  const intl = useIntl();

  return (
    <>
      <WindowTitle title={intl.formatMessage(sectionNames.expressFleet)} />
      <Routes>
        <Route path={""} element={<ExpressFleetListComponent />} />
        <Route
          path={expressFleetOpsUrl + "/"}
          element={<ExpressFleetOpsPage />}
        />
      </Routes>
    </>
  );
};

export default Component;
